import React from 'react';
import { IFormFieldState } from '../../../FormFieldSet';
import SimpleText from '../Text/SimpleText';
import SimpleNumber from '../Number/SimpleNumber';
import SimpleSelect from '../Select/SimpleSelect';
import SimpleDate from '../Date/SimpleDate';
import { CustomFormFieldDefinition } from '@publishing-engine/domain/types/article';
import asDependentFieldComponent from 'src/pages/Organization/public/Journal/SubmissionUpload/components/common/asDependentFieldComponent';

interface ISimpleFieldDisplayProps {
  config: CustomFormFieldDefinition;
  formFieldState: IFormFieldState;
  submissionContextId?: string;
}

const componentsMap: Partial<
  Record<CustomFormFieldDefinition['component'], React.ComponentType<any>>
> = {
  'Custom:TextInput': SimpleText,
  'Custom:TextArea': SimpleText,
  'Custom:NumberInput': SimpleNumber,
  'Custom:IntegerInput': SimpleNumber,
  'Custom:Select': SimpleSelect,
  'Custom:DateInput': SimpleDate
  // TODO: Add more mappings as needed
};

const SimpleFieldDisplay: React.FC<ISimpleFieldDisplayProps> = ({
  formFieldState,
  submissionContextId,
  config
}) => {
  const Component =
    componentsMap[
      formFieldState.formFieldDefinition.component as keyof typeof componentsMap
    ];

  if (!Component) {
    return null;
  }

  return (
    <Component
      formFieldState={formFieldState}
      submissionContextId={submissionContextId}
      config={config}
    />
  );
};

export default asDependentFieldComponent(SimpleFieldDisplay);
